/**
 * Phase 9 (Phase 20: one line per layer) — each stop-loss's last judgement
 * above the Live cards: whose it is (a campaign group's, or a container's
 * own), its verdict and the judge's own sentence ("nothing matched the
 * stop-loss rule on 4,200 SMS across 6 drops", "settled 300 SMS < min sample
 * 500"). Only for layers that auto-send — the report carries them then.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import { ShieldAlert } from 'lucide-react';
import type { DropGenStopLossCheck } from '@trafficpulse/shared';

import { Badge } from '@/components/ui';

const TONE = { PASS: 'success', FAIL: 'destructive', INCONCLUSIVE: 'secondary', PENDING: 'info' } as const;

const badge = (c: DropGenStopLossCheck) => {
  if (c.verdict !== 'FAIL') return c.verdict.toLowerCase();
  return c.resumed ? 'matched — a person resumed it, it keeps sending today' : 'matched — halted for today';
};

const Line: FC<{ check: DropGenStopLossCheck }> = ({ check }) => (
  <li className="flex flex-wrap items-center gap-2 px-3 py-2">
    <ShieldAlert className="h-3.5 w-3.5 text-warning" />
    <span className="font-medium">Stop-loss · {check.scope.name}</span>
    {check.scope.kind === 'container' ? <span className="text-muted-foreground">(its own)</span> : null}
    <Badge tone={check.resumed ? 'warning' : TONE[check.verdict]}>{badge(check)}</Badge>
    <span className="min-w-0 text-muted-foreground">{check.reason}</span>
  </li>
);

export const StopLossLine: FC<{ checks: DropGenStopLossCheck[] }> = ({ checks }) =>
  checks.length === 0 ? null : (
    <ul className="divide-y divide-border/60 rounded-lg border border-border/60 bg-card text-xs">
      {checks.map((c) => (
        <Line key={`${c.scope.kind}:${c.scope.id}`} check={c} />
      ))}
    </ul>
  );
